import { Box, Skeleton } from '@mui/material';
import { PaperFrameStyled } from '@/components/common/paperFrameStyled';

const CashFlowDetailsSkeleton: React.FC = () => {
  return (
    <PaperFrameStyled sx={{ flexGrow: 1, overflow: 'hidden' }}>
      <Box
        sx={{
          display: 'flex',
          padding: '24px',
          height: '100%',
          minHeight: 360,
        }}
      >
        <Skeleton
          variant='rectangular'
          width='100%'
          height='100%'
          sx={{ minHeight: 312, borderRadius: 1 }}
        />
      </Box>
    </PaperFrameStyled>
  );
};

export default CashFlowDetailsSkeleton;
